export default {"src":"/_next/static/media/parkfuchs.ac6cdac7.svg","height":694,"width":843,"blurWidth":0,"blurHeight":0};